var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{attrs:{"center":{
       lat: _vm.content.location.position.lat,
       lng: _vm.content.location.position.lng},"zoom":12}},[_c('GmapMarker',{key:_vm.index,attrs:{"position":_vm.google && new _vm.google.maps.LatLng(
       _vm.content.location.position.lat,
       _vm.content.location.position.lng)}})],1),_c('span',{staticClass:"chawget-msg-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }